import {React,useReducer,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import { Cate} from '../Component/Fetcher'
import Singlemovie from '../Component/Singlemovie'
import Header from '../Component/Header'
import Favourite from '../Component/Favourite'
import Nav from '../Component/Nav'

const initaistate = {
data: [],
error : '',
loading: true
}

const reducer =(state,action)=>{
 switch(action.type){
  case 'success':
    return{
      ...state,
      data:action.payload,
      error : '',
      loading:false

    }

    case 'failed':
      return{
        ...state,
        data:'',
        error :action.errormessage,
        loading:false
      }
 }
}



const Categoriemovie = () => {
const {categoriesid} =useParams ()
  const[mostwatch , dispatch] = useReducer(reducer,initaistate)

  useEffect(()=>{
    Cate({dispatch,categoriesid})
  },[categoriesid])

 
const render=()=>{
return mostwatch.data.map((data)=>
   <Singlemovie key={data.id} data={data}/>
  )
}

return (
    <>
    <Header/>
   
    <div id='slider'>
  <div id='nav-wrapper'>
  <Nav/>
  </div>
 
        <div id='image-wrapper'>
<img src='/asset/marvel-intro.gif'/>

</div>
     </div>
   
     <p id='hot'> Categories</p>
    
      <div id='single-wrapper'>
  {mostwatch.loading?'loading':render()}
  {mostwatch.error?mostwatch.error :''}
      </div>
      <Favourite/>
      </>
    )
  }
  
  export default Categoriemovie